import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';
import css from '@styled-system/css';
import { BLOCKS } from '@contentful/rich-text-types';

import { contentfulParagraphWithImageType } from 'types';
import getContentfulImgixUrl from 'utils/getContentfulImgixUrl';
import Box from 'legacy/components/box';
import Flex from 'legacy/components/flex';
import Section from 'legacy/components/section';
import Image from 'legacy/components/image';
import Heading from 'legacy/components/heading';
import SimpleRichText from 'legacy/components/humanity-v1/primitives/simpleRichText';

const ImageWrapper = styled(Box)(
  css({
    width: ['100%', null, '50%'],
    '& img': {
      borderRadius: 'large',
    },
  })
);

const CopyWrapper = styled(Box)(
  css({
    width: ['100%', null, '50%'],
  })
);

const renderOpts = {
  renderNode: {
    [BLOCKS.HEADING_1]: (node, children) => (
      <Heading as="h1" fontSize={['4', null, '5', null, '6']}>
        {children}
      </Heading>
    ),
  },
};

const ParagraphWithImage = ({ section, renderOptions, ...props }) => {
  const theme = useTheme();
  const imageLeft = section.imageLocation === 'left';

  return (
    <Section {...props}>
      <Section.Inner>
        <Flex flexWrap="wrap" mx={[0, null, -3, -4]}>
          <ImageWrapper
            order={imageLeft ? 'initial' : ['initial', null, 1]}
            px={[0, null, 3, 4]}
          >
            <Image
              src={getContentfulImgixUrl(section.image?.url)}
              sizes={`(min-width: ${theme.breakpoints.md}) calc(50vw - 8rem), (min-width: ${theme.breakpoints.xl}) 504px, calc(100vw - 3rem)`}
              additionalParams={{ ar: '1:1', fit: 'crop' }}
              lazyload
              px={[0, null, 4]}
            />
          </ImageWrapper>
          <CopyWrapper
            order={imageLeft ? 'initial' : ['initial', null, -1]}
            mt={[3, null, 0]}
            px={[0, null, 3, 4]}
          >
            <SimpleRichText
              content={section.content?.json}
              renderOptions={renderOptions ?? renderOpts}
            />
          </CopyWrapper>
        </Flex>
      </Section.Inner>
    </Section>
  );
};

ParagraphWithImage.propTypes = {
  section: contentfulParagraphWithImageType.isRequired,
  renderOptions: PropTypes.shape({
    renderNode: PropTypes.object,
    renderMark: PropTypes.object,
  }),
};

ParagraphWithImage.defaultProps = {
  renderOptions: null,
};

export default ParagraphWithImage;
